import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const uniqueVoucherVoucherPromoAddEditRolesRBAC = {
  pageID: '74d6df54e2d9d07646c36f8075577cb2',
  elementID: {
    ViewUniqueVoucher: '86f4b62631ba68b24578a2ad47f42fc4',
    CreateUpdate: '811cb11a5c9ac4f3eb81196961bb7a51',
  },
} as const

export const useRBACUniqueVoucherVoucherPromoAddEditPage = createUseRBAC(
  uniqueVoucherVoucherPromoAddEditRolesRBAC.elementID,
)

export type UseRBACUniqueVoucherVoucherPromoAddEditPageType = ReturnType<
  typeof useRBACUniqueVoucherVoucherPromoAddEditPage
>
